export default __webpack_public_path__ + "static/media/web-app.c16426a7.svg";